import { useMemo } from 'react';
import { Box } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { FILTER_DATE_RANGE_CLASS } from 'components/common/dataGrid/filterPanel/constants';
import {
  DateRangePickerBase,
  DateRangeValue,
  isDateRangeType,
} from 'components/common/dateRangePicker';

export const DateRangeFilterInput = (
  props: GridFilterInputValueProps
): JSX.Element => {
  const { item, applyValue } = props;

  const current: DateRangeValue = useMemo(() => {
    if (isDateRangeType(item.value)) {
      return item.value;
    }
    return { start: null, end: null };
  }, [item.value]);

  const handleChange = (value: DateRangeValue): void => {
    applyValue({
      ...item,
      value,
    });
  };

  return (
    <Box className={FILTER_DATE_RANGE_CLASS} sx={{ width: '100%', minWidth: 0 }}>
      <DateRangePickerBase
        value={current}
        onChange={handleChange}
        normalizeTwoDigitYearTo2000
        views={['day', 'month', 'year']}
        openTo='day'
      />
    </Box>
  );
};